function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 32,
  r: 28
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 40,
  r: 20
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4 108c4.88-29.77 22.34-47.94 44-47.94S87.11 78.25 92 108"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M80.85 78.2C86.73 66.65 96.56 60 108 60c15.75 0 28.44 12.62 32 33.27"
});

var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 144 112",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgUsers;